import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getScenarioPhases, getAffectedProjects, calculateScenarioImpact } from "../api";
import { ScenarioPhase, ScenarioImpact } from "../types";

export const useScenarioPhases = () => {
    return useQuery({
        queryKey: ["visionStudio", "scenarioPhases"],
        queryFn: getScenarioPhases,
    });
};

export const useAffectedProjects = (phaseIds: string[]) => {
    return useQuery({
        queryKey: ["visionStudio", "affectedProjects", phaseIds],
        queryFn: () => getAffectedProjects(phaseIds),
        enabled: phaseIds.length > 0,
    });
};

export const useCalculateScenarioImpact = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: ({
            delayDuration,
            selectedPhaseIds,
        }: {
            delayDuration: number;
            selectedPhaseIds: string[];
        }) => calculateScenarioImpact(delayDuration, selectedPhaseIds),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["visionStudio", "scenarioImpact"] });
        },
    });
};
